module.exports = __webpack_public_path__ + "stripe-square-cutout-9a1c0f4df6b1f05cd9755d00406beed1.png";